<template>
  <div class="container">

    <h1><i class="fa fa-user"></i> users</h1>
    <div v-if="users" class="userbase-info">
      <div>{{users.length}} users ({{users.filter(u => (!u.isAdmin && !u.isTester && !u.isDevAcquaintance)).length}} unrelated to dev)</div>
    </div>
    <hr>



    <table style="width:100%">
      <thead>
        <tr style="border-bottom: 1px solid black;">
          <th style="text-align: center;">roles</th>
          <th>name</th>
          <th>auth</th>
          <th>joined</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(user) in users" :key="user._id" class="user-table-row" :class="{'marked-for-deletion': user.isMarkedForDeletion}">

          <td class="roll-icons">
            <i v-if="user.isAdmin" class="fa fa-wrench"></i>
            <i v-if="user.isTester" class="fa fa-heartbeat"></i>
            <i v-if="user.isDevAcquaintance" class="fa fa-handshake-o"></i>
            <i v-if="user.isLegacyUser" class="fa fa-gift"></i>
            <i v-if="!user.isLegacyUser && !!user.membershipType" class="fa fa-credit-card-alt"></i>
          </td>

          <td :style="{'font-weight': isMe(user)? 'bold' : 'normal'}">
            <router-link :to="`/admin/user/${user._id}`">
              <ProfilePicture :user="user" :size="20"></ProfilePicture> {{user.username}}
            </router-link>
          </td>

          <td :style="{'font-weight': isMe(user)? 'bold' : 'normal'}">
            {{user.email}}
            <span class="auth-icons">
              <i v-if="user.isEmailAuthed" class="fa fa-envelope-o"></i>
              <img v-if="user.isGoogleAuthed" :src="`${$imagePathBase}logos/google-logo.svg`"/>
              <i v-if="user.isAppleAuthed" class="fa fa-apple"/>
            </span>
          </td>

          <td :style="{'font-weight': isMe(user)? 'bold' : 'normal'}">
            {{dateDisplayString(user.accountCreatedDate)}}
          </td>

        </tr>

      </tbody>
    </table>

  </div>
</template>


<script>
import axios from "axios";
import ProfilePicture from "@/components/profile/ProfilePicture.vue";
import { userStore } from "@/userStore";

export default {
  name: "AdminUsersPage",
  /* eslint-disable vue/no-unused-components */
  components: {ProfilePicture},
  data() {
    return {
      waitingForResponse: false,
      users: null,
    }
  },
  created() {
    this.waitingForResponse = true;

    // get the schedule for the given provider
    axios.get(`/api/admin/users`)
        .then((response) => {
          this.users = response.data;

          // sort so most-recently-created accounts are at the top
          this.users.sort((userA, userB) => {
            if ( userA.accountCreatedDate < userB.accountCreatedDate ) {
              return 1;
            }
            if ( userA.accountCreatedDate > userB.accountCreatedDate ) {
              return -1;
            }
            return 0;
          });
        })
        .catch((err) => {
          console.error(`error calling /api/admin/users : ${err}`)
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
  },
  methods: {
    dateDisplayString(_date) {
      const dateObj = ( _date instanceof Date )? _date : new Date(_date);
      return dateObj.toDateString();
    },

    isMe(_user) {
      return ( _user?._id === userStore.getUserId() );
    }
  }
}
</script>


<style scoped>

.userbase-info {
  margin-left: 50px;
  margin-right: 50px;
}

.user-table-row {
  height: 2em;
  border-bottom: var(--bs-secondary-color);

  &:nth-child(even) {
   background-color: var(--bs-secondary-bg);
  }

  &.marked-for-deletion {
    background-color: pink;
  }

  a {
    text-decoration: inherit;
  }

}

.roll-icons {
  text-align: center;

  .fa {
    padding: 0 2px 0 2px;

    &.fa-gift {
      color: var(--mol-color-gold-text);
    }

    &.fa-credit-card {
      color: limegreen;
    }
    &.fa-credit-card-alt {
      color: limegreen;
    }

    &.fa-wrench {
      color: crimson;
    }

    &.fa-heartbeat {
      color: blue
    }
  }
}

.card {
  margin-top: 50px;
  margin-botton: 50px;
}
.profile-pic {
  border-radius: 50%;
  margin-top: -4px;
}

.auth-icons {

  .fa, img {
    font-size: 1em;
    height: 1em;
    padding: 0 2px 0 2px;
    margin-top: -2px;
  }
}

.fa-apple {
  color: black;
}

html[data-bs-theme=dark] {
  .fa-apple {
    color: white;
  }
}



</style>